// src/client/hooks/useLogout.js
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../UserContext";
import axiosInstance from "../../axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

const useLogout = () => {
  const userContext = useContext(UserContext);
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");

      await axiosInstance.post(
        `${API_URL}/users/logout`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Logout request failed:", error);
    } finally {
      sessionStorage.clear();
      localStorage.clear();
      userContext.setUser();
      userContext.setEmail();
      userContext.setUsername();
      navigate("/login-signup", { replace: true });
    }
  };

  return logout;
};

export default useLogout;
